import React from 'react'

export interface ITabContext {
  activeTab: string
  keepTabsInView?: boolean
  addTab: (fields: { value: string; label: string; count?: number; hidden?: boolean }) => void
  updateTab: (
    tabValue: string,
    fields: { label?: string; count?: number; hidden?: boolean },
  ) => void
}
export const TabContext = React.createContext<ITabContext>({
  activeTab: null,
  keepTabsInView: false,
  addTab: (fields) => null,
  updateTab: (tabValue, fields) => null,
})

export const withTabContext = (Component: any) => (props) => {
  return (
    <TabContext.Consumer>
      {({ activeTab, addTab, updateTab, keepTabsInView }) => (
        <Component
          {...props}
          activeTab={activeTab}
          addTab={addTab}
          updateTab={updateTab}
          keepTabsInView={keepTabsInView}
        />
      )}
    </TabContext.Consumer>
  )
}
